import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { deleteScenarioGroupData } from '../actions/scenarioGroupAction';
import { connect } from 'react-redux';
import { deleteDb } from './UserFunctions'
import PropTypes from 'prop-types';

class DeleteScenarioGroupModal extends Component {
    constructor(props){
        super(props)
        console.log(props)
        console.log(props.content.scenario_uuid)
        this.handleDeleteContent = this.handleDeleteContent.bind(this);

        this.state = {
            content: ''
        }
    }

    handleDeleteContent() {
        console.log(this.state.content);
        const delete_api_url = (window.location.origin).concat('/delete_scenario_group_for_open_loop')
        const data_for_api = {
            scenario_uuid : this.props.content.scenario_uuid,
            scenario_group_id : this.props.content.scenario_group_id
        }
        deleteDb(delete_api_url, data_for_api).then(res => {
            console.log("Status of updation : ", res['data']['status'])
            if(res['data']['status'] === "Deleted Successfully"){
                this.props.dispatch(deleteScenarioGroupData(this.state.content));
                this.props.handleDeleteModalClose();
            }

        })

    }

    componentDidMount() {
        this.setState( (prevState) => {
            if(this.props.content) {
                return {
                    ...prevState,
                    content: this.props.content
                }
            } else {
                return {
                    content: ''
                }
            }
        })
    }

    render() {
        return (
            <Modal isOpen={!!this.props.deleteSelectedRow}>
                <ModalHeader
                    toggle={this.props.handleDeleteModalClose}
                    style={{ color:"#524fa1" }}
                >
                    Delete Scenario Group
                </ModalHeader>
                <ModalBody>
                    <div>
                        Are you sure want to delete ?
                    </div>
                </ModalBody>
                <ModalFooter>
                  <button className="btn btn-danger" onClick={this.handleDeleteContent}>Delete</button>
                  <Button className="btn" onClick={this.props.handleDeleteModalClose}>Cancel</Button>

                </ModalFooter>
              </Modal>
        )
    }
}
DeleteScenarioGroupModal.propTypes={
content:PropTypes.string,
dispatch:PropTypes.string,
handleDeleteModalClose:PropTypes.string,
deleteSelectedRow:PropTypes.string,
useHistory:PropTypes.string,
deleteContent:PropTypes.string,
//navigateHome:PropTypes.string,
}
DeleteScenarioGroupModal.defaultProps= {
content:[],
dispatch:[],
handleDeleteModalClose:[],
deleteSelectedRow:[],
useHistory:[],
deleteContent:[],
//navigateHome:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect()(DeleteScenarioGroupModal);
